import {Injectable} from '@angular/core';
import {SelectableItem} from '@brunata-angular/ui';
import {LatLng} from 'leaflet';
import {DateTime} from 'luxon';

@Injectable({
    providedIn: 'root',
})
export class MeterListMapService {
    zoom: number | undefined;
    center: LatLng | undefined;
    meterId: string | null = null;
    startDate: DateTime | undefined;
    endDate: DateTime | undefined;
    statusFilter: string[] | null = null;
    meterTypeFilter: SelectableItem[] | undefined;
    eventsFilter: SelectableItem[] | undefined;
}
